import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { RecordAttention } from "@/components/common/record-attention"
import { AppShell } from "@/components/layout/app-shell"
import { useAttentionSection } from "@/hooks/use-attention-section"
import { FirmProperties } from "@/features/firms/components/firm-properties"
import { FirmSidebar } from "@/features/firms/components/firm-sidebar"
import { firmQueries } from "@/queries/firms"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(firmQueries.detail(params.firmId)),
  component: FirmWorkspaceLayout,
})

function FirmWorkspaceLayout() {
  const { firmId } = Route.useParams()
  const section = useAttentionSection()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <>
      <AppShell
        sidebar={<FirmSidebar firm={firm} />}
        aside={<FirmProperties firm={firm} />}
        attention={
          section ? (
            <RecordAttention subject="firm" id={firmId} section={section} />
          ) : null
        }
      >
        <Outlet />
      </AppShell>
    </>
  )
}
